// extracted by mini-css-extract-plugin
export default {"HalfHalf":"half-half_HalfHalf__1IGEs","evolved":"half-half_evolved__2Qocz"};